import axios from "axios";
import { GetCriteriaDistributionResponseType, GetScreenerDataPayloadType, GetScreenerDataResponseType, GetScreenerSectorResponseType } from "../types/screener.type";

import { apiBase } from './apiBase';
export const getScreenerSectors = (token: string): Promise<GetScreenerSectorResponseType[]> => {
    return new Promise(async (resolve, reject) => {
        axios.get(`${apiBase()}/screener/sector`, {
            params: {
                token: token,
            },
        }).then((res) => {
            if (res.data.data) {
                resolve(res.data.data);
            } else return;
        }).catch((err) => {
            reject(err);
        });
    });
};

export const getCriteriaDistribution = (cid: string, option: string | undefined, region: string, sector: string, token: string): Promise<GetCriteriaDistributionResponseType> => {
    return new Promise(async (resolve, reject) => {
        axios.post(`${apiBase()}/screener/criteria`, {
            cid: cid,
            option: option,
            country: region && region.trim() !== '' ? region : "AU",
            sector: sector,
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        }).then((res) => {
            if (res.data.data) {
                resolve(res.data.data);
            } else return;
        }).catch((err) => {
            reject(err);
        });
    });
};

export const getScreenerData = (payload: GetScreenerDataPayloadType, token: string): Promise<GetScreenerDataResponseType> => {
    return new Promise(async (resolve, reject) => {
        axios.post(`${apiBase()}/screener/result`, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        }).then((res) => {
            if (res.data) {
                resolve(res.data);
            } else return;
        }).catch((err) => {
            reject(err);
        });
    });
};